import React from 'react'
import PropTypes from 'prop-types'
import flatmap from 'lodash.flatmap'

import getBookingReminders from 'lib/getBookingReminders'

import './index.css'

const BookingOverviewReminders = ({bookings}) => {
  const reminders = flatmap(bookings.edges, ({node}) => getBookingReminders(node))
  const reminder = reminders.find(r => r.type === 'key-pickup')

  if (!reminder) {
    return null
  }

  return (
    <div className="booking-reminders">
      <div className="booking-reminders-content">
        <div key={reminder.type}>
          <img src={reminder.iconInverted} alt={reminder.text} width="24" height="24" className="reminder-icon" />
          {reminder.text}
        </div>
      </div>
    </div>
  )
}

BookingOverviewReminders.propTypes = {
  bookings: PropTypes.object.isRequired,
}

export default BookingOverviewReminders
